import { BurnEstimate, BurnProvider } from '@/page-components/BurnEstimate'

const BurnEstimatePage = () => {
  return (
    <BurnProvider>
      <BurnEstimate />
    </BurnProvider>
  )
}

export default BurnEstimatePage
